import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags'; 
import { Link } from 'react-router-dom'; // Added Meta Tag npm Package
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledTooltip, Badge } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { Button} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import Select from 'react-select';

    const Users = () => {

        toastr.options = TOAST_OPTIONS;

        const [modal_users, setmodal_users] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [usersList, setUsersList] = useState([]);
        const [titles, setTitles] = useState([])
        const [modules, setModules] = useState(["CMMS","WATER PRODUCTION", "WQMIS","CCTS","PAYMENTS", "GIS", "HRMIS","INVENTORY","PROJECTS"]);
        const [areas, setAreas] = useState([])
        const [selectedDistricts, setSelectedDistricts] = useState("")
        
        const [deptList, setDeptList] = useState([])
        const [levels, setLevels] = useState(["ADMINISTRATOR", "HUMAN RESOURCE OFFICER","COMPLAINT MANAGER","CUSTOMER SUPPORT REPRESENTATIVE","QUALITY ASSURANCE OFFICER", "READ ONLY AUDITOR", "SYSTEM ANALYST", "CASHIER", "CHIEF CASHIER","SYSTEM USER"]);
        const [user, setUser] = useState(null);
        const [isloading, setIsloading] = useState(false)

        const [id, setId] = useState('')
        const [name, setName] = useState('')
        const [title, setTitle] = useState('')
        const [selectedDept, setSelectedDept] = useState('')
        const [phone, setPhone] = useState('')
        const [email, setEmail] = useState('')
        const [category, setCategory] = useState('')
        const [selectedAreas, setSelectedAreas] = useState([])
        const [userStatus, setUserStatus] = useState('')
        const [dateRegistered, setDateRegistered] = useState('')
        const [lastLogin, setLastLogin] = useState('')
        const [changePass, setChangePass] = useState('')

        const [sId, setSId] = useState('')
        const [sName, setSName] = useState('')
        const [sTitle, setSTitle] = useState('')
        const [sDept, setSDept] = useState('')
        const [sCategory, setSCategory] = useState('')
        const [sArea, setSArea] = useState('')

        const [duties, setDuties] = useState(['full-time', 'shift'])
        const [dutyType, setDutyType] = useState('full-time')
        const [showTime, setShowTime] = useState(false)
        const [dutyStart, setDutyStart] = useState('07:00:00')
        const [dutyEnd, setDutyEnd] = useState('12:00:00')

        const [selectedEmployee, setSelectedEmployee] = useState(null)
        const [employeeOptions, setEmployeeOptions] = useState([])

        const employeeOptionsRef = useRef([]);

        const [permissions, setPermissions] = useState({
          complaints: { view: false, add: false, assign: false, 're-assign': false, close: false },
          payments: { view: false, add: false, assign: false, delete: false },
          work_requests: { view: false, add: false, assign: false, delete: false },
          work_orders: { view: false, create: false, update: false, delete: false },
          assets: { view: false, add: false, update: false, delete: false },
          production: { view: false, add: false, update: false, delete: false },
          human_resources: { view: false, add: false, update: false, delete: false },
          inventory: { view: false, add: false, update: false, delete: false },
          billing: { view: false, add: false, update: false, delete: false },
          water_quality: { view: false, add: false, update: false, delete: false },
          gis: { view: false, add: false, update: false, delete: false },
          finance: { view: false, add: false, update: false, delete: false }
        });

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_users = () => {
          setmodal_users(!modal_users);
          removeBodyCss();
        }
        const handleClearSearch = () =>{
          setSId('')
          setSName('');
          setSTitle('')
          setSArea('')
          setSDept('')
          setSCategory('')
          fetchData()
        }
        const fetchData = async () => {
          const data = {
            id    :sId,
            name  :sName,
            title :sTitle,
            dept  :sDept,
            category:sCategory,
            area  : sArea
          }
          
          try {
            
            setIsloading(true)
            let arr = []; const data1 = { status:''}; setIsloading(true)
            const r = await axios.post(url.HREMPLOYEESFILTER, JSON.stringify(data1), Config)
            r.data.map((a)=>{ arr.push( {value:a.id, label:a.name}) })
            setEmployeeOptions(arr)
            employeeOptionsRef.current = arr;
            const d = await axios.get(url.DEPTS, Config)
            setDeptList(d.data)
            const l = await axios.get(url.TITLES, Config)
            setTitles(l.data)
            const t = await axios.get(url.TERRITORIES, Config)
            setAreas(t.data)
            const u = await axios.post(url.USERSFILTER, JSON.stringify(data), Config)
            setUsersList(u.data);
            
          } catch (e) {
            console.log(e);
          } finally {
            setIsloading(false)
          }
        }
        const handleFilterData = async () =>{
          setIsloading(true)
          const data = {
            id    :sId,
            name  :sName,
            title :sTitle,
            dept  :sDept,
            category:sCategory,
            area  : sArea
          }
          try {
            const u = await axios.post(url.USERSFILTER, JSON.stringify(data), Config)
            setUsersList(u.data);
          } catch (e) {
            console.log(e)
          } finally {
            setIsloading(false)
          }
        }
        useEffect(() => {
         fetchData();
        },[]);

        const handleOptionChange = (event) => {
          const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value);
          setSelectedAreas(selectedValues);
        };   
        const validateTime = (time) => {
          const timeFormat = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
          if (timeFormat.test(time)) {
              const [hours, minutes, seconds] = time.split(':').map(Number);
              if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59 && seconds >= 0 && seconds <= 59) {
                  return true; 
              }
          }
          return false;
      }
        const handleAddUser = () => {  
          if(name.trim().length < 3){
            toastr.error('Enter staff name')
          }else if(title.trim().length < 1){
            toastr.error('Enter staff title')
          }else if(selectedDept == ""){
            toastr.error('Please select a department from dropdown list.')
          }else if(phone.trim().length < 10){
            toastr.error('Enter phone number in format 0775....')
          }else if(email.trim().length < 4){
            toastr.error('Enter staff email address')
          }else if(selectedAreas.length < 1){
            toastr.warning('Select at least one area for the user');
          }else if((dutyType == 'shift') && (!validateTime(dutyStart) || !validateTime(dutyEnd))){
            toastr.warning('Duty start and end Time should be in formart HH:MM:SS')
          }else{
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            const data = {
                "id"    : isEdit?id:'', 
                "name"  : name,
                "title" : title,
                "dept"  : selectedDept,
                "phone" : phone,
                "email" : email,
                "category"  : category,
                "areas"     : selectedAreas.join(','),
                "districts" : selectedDistricts,
                "status"    : userStatus,
                "uuId"      : obj.id,
                "uuName"    : obj.username,
                "changePass": changePass,
                "dutyType"  : dutyType,
                "dutyStart" : dutyStart,
                "dutyEnd"   : dutyEnd,
                "hrmId"     : selectedEmployee?.value,
                "action"    : isEdit?'edit':'add'
            }
            setIsloading(true)
            axios.post(url.USERS, JSON.stringify(data), Config).then((r)=>{
              if(r.data.status == '0'){
                  toastr.error(r.data.message); 
              }else{
                  toastr.success(r.data.message); 
                  fetchData();
                  tog_users();
                  clearData();
              }
            }).catch((e)=>{
              console.log(e);
            }).finally(()=>{
              setIsloading(false)
            })
          }
        }
        
        const handleClickEdit = async (row) => {        
          tog_users(); 
          setIsEdit(true);
          setId(row.id)
          setName(row.name)
          setTitle(row.titleId)
          setSelectedDept(row.dept)
          setPhone(row.phone)
          setEmail(row.email)
          setCategory(row.category)
          setSelectedAreas(row.modules.split(','))
          setDutyType(row.dutyType)
          if(row.dutyType == 'shift'){
            setDutyStart(row.dutyStart)
            setDutyEnd(row.dutyEnd)
            setShowTime(true)
          }else{
            setShowTime(false)
          }
          if(row.districts != null){
            setSelectedDistricts(row.districts)
          }
          setUserStatus(row.status)
          setDateRegistered(row.dateRegistered);
          (row.lastLogin != null || row.lastLogin != undefined) && setLastLogin(row.lastLogin);
          setChangePass(row.changePass)
          setSelectedEmployee(employeeOptionsRef.current.find(option => option.value == row.hrmsId))
        }
        const clearData = () =>{
          setIsEdit(false); 
          setId('')
          setName('')
          setTitle('')
          setSelectedDept('')
          setPhone('')
          setEmail('')
          setCategory('')
          setSelectedAreas([])
          setUserStatus('')
          setDateRegistered('')
          setLastLogin('')
          setChangePass('')
          setDutyType('full-time')
          setDutyStart('07:00:00')
          setDutyEnd('12:00:00')
          setSelectedEmployee(null)
        }
        const handleClickAdd = () => {  
          setIsEdit(false);
          clearData() 
          tog_users();  
        }

        const columns = [

        {
          dataField: 'name',
          text: 'Name',
          sort: true
        },
        {
          dataField: 'title',
          text: 'Title',
          sort: true
        },
        {
          dataField: 'deptName',
          text: 'Department',
          sort: true
        },
        /*{
          dataField: 'email',
          text: 'Email',
          sort: true
        },*/
        {
            dataField: 'lastLogin',
            text: 'Last Login',
            sort: true
          },
          {
            dataField: 'status',
            text: '',
            sort: true,
            formatter: statusFormatter
          },
        {
          dataField: "",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'id',
          order: 'asc'
        }];
        function statusFormatter(cellContent, row) {
          if (row.status == "Active") {
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else if(row.status == "Off-Duty"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function actionFormatter(cellContent, row){
          return(
            <>
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={() => { handleClickEdit(row); }}
                >
                  Details
            </Button>
          </>
          )
        }

        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Users | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>


                        <Row>


                            <Col lg="12">
                          
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                <div>
                             
                                </div>
                                
                  
                                

                                                <Row className="justify-content-center mb-1">
                                                <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Search by Name</label>
                                                          <input type='text' className="form-control form-control-sm" value={sName} onChange={(e)=>setSName(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Title/Designation</label>
                                                          <select className="form-select form-select-sm" value={sTitle} onChange={(e)=>setSTitle(e.target.value)}>
                                                            <option>All</option>
                                                            {titles.map((r,k)=>(
                                                              <option value={r.id} key={k}>{r.title}</option>
                                                            ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Department</label>
                                                          <select className="form-select form-select-sm" value={sDept} onChange={(e)=>setSDept(e.target.value)}>
                                                            <option>All</option>
                                                            {deptList.map((r,k)=>(
                                                              <option value={r.id} key={k}>{r.name}</option>
                                                            ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Category</label>
                                                          <select className="form-select form-select-sm" value={sCategory} onChange={(e)=>setSCategory(e.target.value)}>
                                                            <option>All</option>
                                                            {levels.map((a,k)=>(
                                                                <option key={k} value={a}>{a}</option>
                                                              
                                                            ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                
                                                </Row>
                                       
                                                <Row  className="justify-content-center mb-2 mt-3">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add System User
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  
                                                </Row>
                                                </CardBody>
                                                </Card>
                        
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">USERS ({usersList.length})</h5>
                                <CardBody>

                                
                                <Modal isOpen={modal_users} toggle={() => { tog_users();}} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit User ': 'Add User' }</h5>
                                    <button onClick={() => { setmodal_users(false);}}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    
                          
                                    <Row>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Name</label>
                                            <input type="text" className="form-control" value={name} onChange={(e)=>setName(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Title/Designation</label>
                                            <select className="form-select" value={title} onChange={(e)=>setTitle(e.target.value)}>
                                              <option value={``}></option>
                                              {titles.map((r,k)=>(
                                                <option value={r.id} key={k}>{r.title}</option>
                                              ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Department</label>
                                            <select className="form-select" value={selectedDept} onChange={(e)=>setSelectedDept(e.target.value)}>
                                              <option value={``}></option>
                                              {deptList.map((r,k)=>(
                                                <option value={r.id} key={k}>{r.name}</option>
                                              ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Phone</label>
                                            <input type="text" className="form-control" value={phone} onChange={(e)=>setPhone(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>E-mail</label>
                                            <input type="text" className="form-control" value={email} onChange={(e)=>setEmail(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Category</label>
                                            <select className="form-select" value={category} onChange={(e)=>setCategory(e.target.value)}>
                                              <option>Select</option>
                                              {levels.map((a,k)=>(
                                                  <option key={k} value={a}>{a}</option>
                                                
                                              ))}
                                            </select>
                                        </div>
                                    </Col>
                                    
                                    
                                    

                                    {isEdit && <>
                                      <Col xl={6}>
                                        <div className="mb-3">
                                            <label>User status</label>
                                            <select className="form-select" value={userStatus} onChange={(e)=>setUserStatus(e.target.value)} >
                                              <option value='Deactivated'>Deactivated</option>
                                              <option value='Active'>Active</option>
                                              <option value='Off-Duty'>Off-Duty</option>
                                            </select>
                                        </div>
                                      </Col>
                                      <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Change password on next login</label>
                                            <select className="form-select" value={changePass} onChange={(e)=>setChangePass(e.target.value)} >
                                              <option value='1'>Yes</option>
                                              <option value='0'>No</option>
                                            </select>
                                        </div>
                                      </Col>
                                      <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Date registered</label>
                                            <input type="text" className="form-control" value={dateRegistered} onChange={(e)=>setDateRegistered(e.target.value)} disabled={true}/>
                                        </div>
                                      </Col>
                                      <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Last logged in</label>
                                            <input type="text" className="form-control" value={lastLogin} onChange={(e)=>setLastLogin(e.target.value)} disabled={true}/>
                                        </div>
                                      </Col>
                                    </>}
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Districts</label>
                                            <select className="form-select" value={selectedDistricts} onChange={(e)=>setSelectedDistricts(e.target.value)}>
                                              <option value="">All</option>
                                              {areas.map((a,k)=>(
                                                  <option key={k} value={a.id}>{a.name}</option>
                                                
                                              ))}
                                            </select>
                                        </div>
                                    </Col> 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Modules</label>
                                            <select className="form-select" multiple size={9} value={selectedAreas} onChange={(e)=>handleOptionChange(e)}>
                                              {modules.map((a,k)=>(
                                                  <option key={k} value={a}>{a}</option>
                                                
                                              ))}
                                            </select>
                                        </div>
                                    </Col> 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Duty Type</label>
                                            <select className="form-select" value={dutyType} 
                                                onChange={(e)=>{
                                                  setDutyType(e.target.value);
                                                  if(e.target.value == 'shift'){ setShowTime(true); }else{ setShowTime(false); }
                                                  }}>
                                              {duties.map((a,k)=>(
                                                  <option key={k} value={a}>{a}</option>
                                              ))}
                                            </select>
                                        </div>
                                    </Col>
                                    {showTime && (<>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Duty Start </label>
                                            <input type="text" className="form-control" value={dutyStart} onChange={(e)=>setDutyStart(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Duty End </label>
                                            <input type="text" className="form-control" value={dutyEnd} onChange={(e)=>setDutyEnd(e.target.value)} />
                                        </div>
                                    </Col>
                                    </>)} 
                                    {!isloading && (
                                    <Col xl={12}>
                                          <div className="mb-3">
                                              <label>Employee Name in HRMS</label>
                                              <Select value={selectedEmployee} onChange={(oo)=>{setSelectedEmployee(oo)}} options={employeeOptions} isSearchable/>
                                          </div>
                                      </Col>
                                    )}
                                    </Row>
                                  </div>
                                  
                                  <div className="modal-footer">
                                    {isloading?`Please wait...`:(<>
                                    <button  onClick={() => { tog_users(); }} className="btn btn-danger" data-dismiss="modal">Close</button>
                                    <button className="btn btn-success" onClick = {()=>{handleAddUser()}}>Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                {usersList && (usersList.length > 0) && (
                                    <>
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ usersList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ usersList } 
                                                  columns={ columns } 
                                                  striped
                                                  //hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>

                                    </>
                                )}
                                {usersList && (usersList.length < 1) && (
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                        </div>
                                        <div>
                                        <h5>No Users Found</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>

                                )}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Users;